import { useEffect, useRef } from "react";

export default function useStarfield() {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let stars = [], raf;
    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      stars = Array.from({ length: 200 }, () => ({
        x: Math.random() * canvas.width, y: Math.random() * canvas.height,
        r: Math.random() * 1.2 + 0.2, phase: Math.random() * Math.PI * 2,
        speed: Math.random() * 0.01 + 0.003,
      }));
    };
    const draw = (t) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stars.forEach(s => {
        const a = 0.3 + 0.5 * Math.sin(s.phase + t * 0.001 * s.speed * 100);
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(245,240,232,${a})`; ctx.fill();
      });
      raf = requestAnimationFrame(draw);
    };
    window.addEventListener("resize", resize); resize(); raf = requestAnimationFrame(draw);
    return () => { window.removeEventListener("resize", resize); cancelAnimationFrame(raf); };
  }, []);
  return ref;
}
